var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { Children, forwardRef } from "react";
import Legend from "./Legend";
import { MessagesGroup } from "../MessageGroup";
var FieldsetV2 = forwardRef(function (_a, ref) {
    var id = _a.id, inline = _a.inline, state = _a.state, children = _a.children, className = _a.className, style = _a.style, otherProps = __rest(_a, ["id", "inline", "state", "children", "className", "style"]);
    var computedClassName = "ssg-fieldset fr-fieldset";
    if (state) {
        computedClassName += " fr-fieldset--".concat(state);
    }
    if (className) {
        computedClassName += " ".concat(className);
    }
    var legendComponent = undefined;
    var elementsComponent = [];
    var formMessageComponent = undefined;
    Children.forEach(children, function (child) {
        switch (child.type) {
            case Legend:
                legendComponent = child;
                break;
            case MessagesGroup:
                formMessageComponent = child;
                break;
            default:
                elementsComponent.push(child);
                break;
        }
    });
    return (React.createElement("fieldset", __assign({}, otherProps, { ref: ref, id: id, style: style, className: computedClassName, role: state && ["valid", "error", "warning"].includes(state) ? "group" : "" }),
        legendComponent,
        elementsComponent.map(function (child, index) { return (React.createElement("div", { key: index, className: "".concat(inline ? "fr-fieldset__element fr-fieldset__element--inline" : "fr-fieldset__element", " ").concat(className || ""), style: style }, child)); }),
        formMessageComponent));
});
export default FieldsetV2;
